import { DesignProp, GeneralProp } from "../PropCategories";

export const listStylePosition = {
  prop: "style-attribute",
  name: "List Style Position",
  nameI18n: "builder_ui.prop_type.list_style_position",
  type: "select",
  defaultValue: "outside",
  category: [DesignProp, GeneralProp],
  options: [
    {
      label: "Outside",
      labelI18n:
        "builder_ui.prop_type.styles.list_style_position_options.outside",
      value: "outside",
    },
    {
      label: "Inside",
      labelI18n:
        "builder_ui.prop_type.styles.list_style_position_options.inside",
      value: "inside",
    },
  ],
} as const;
